import { STD_STATE } from '../actions/types';
import { ICourseItem } from '../types/Mentor';
import { CollectionNote, PersonalCollectionNoteList, ListPersonalCollectionNotes, CourseNote } from '../types/User';

interface ICourseList {
  basic: any,
  necessary: any,
  allCourse: any
}

export interface IStdState {
  courseList: ICourseList | null,
  enrolled: ICourseList | null,
  course: ICourseItem | null,
  careerPath: any,
  courseInfo: any,
  lessonInfo: any,
  article: string | null,
  acLoad?: boolean,
  notesList: any;
  collectionNotes: CollectionNote;
  notesDetail: any;
  GPTHistories: any
  GPTMsg: any
  personalNotes:ListPersonalCollectionNotes|null;
  collectionPersonalNotes:PersonalCollectionNoteList|null;
  listCourseNotes: CourseNote[];
  loading: boolean;
}

const INITIAL_STATE: IStdState = {
  careerPath: [],
  courseInfo: null,
  lessonInfo: null,
  courseList: null,
  enrolled: null,
  course: null,
  article: null,
  acLoad: false,
  notesList: [],
  collectionNotes: {
    numberOfCollectionNote: 0,
    list: []
  },
  notesDetail: null,
  personalNotes: null,
  GPTHistories: [],
  GPTMsg: [],
  collectionPersonalNotes: null,
  listCourseNotes: [],
  loading: false
};

export const studentReducer = (state = INITIAL_STATE, action: any): IStdState => {
  switch (action.type) {
    case STD_STATE: {
      return { ...state, ...action.payload };
    }
    default:
      return { ...state };
  }
};
export default studentReducer;
